import { Component, OnInit, Inject, OnDestroy, HostListener } from '@angular/core';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType, PublicClientApplication } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientAppInputParameters } from './Model/ClientAppInputParametersModel';
import { environment } from 'src/environments/environment';
import { TranslateService } from "@ngx-translate/core";
import { CommonUtilService } from './service/common-util.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit, OnDestroy {
  title = 'RPostAuthUI';
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  clientId = "";
  callBackUrlFromQueryString = '';
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private commonUtilSvc: CommonUtilService,
    private router: Router
  ) {

    //this.route.params.subscribe( params => this.clientId=params['clientId']);
    this.clientId = localStorage.getItem('clienIdLS')!;
    this.route.queryParams.subscribe(params => {
      this.callBackUrlFromQueryString = params['CallBackUrl'];

    });

    translate.setDefaultLang('en-us');
    //translate.use('en');


  }

  LogError(type: string, logText: string, clientId: string) {
    this.commonUtilSvc.LogError(type, logText, clientId);
    /* .subscribe({
      next: (resp) => {
        console.log(resp);

      }
      ,
      error: (e) => console.error(e)
    }); */
  }



  ngOnInit(): void {

    if (window.opener && window.opener !== window) {
      //alert('popup');
      localStorage.setItem("IsPopupClosedFromRCAP", 'Y');
      window.close();
      //window.location.href='http://localhost:63183/Login/SSOCallBack' //this.callBackUrlFromQueryString;
    }

    this.isIframe = window !== window.parent && !window.opener && ((window.location.pathname.indexOf('resetpassword') > -1) || (window.location.pathname.indexOf('email-authentication') > -1) || (window.location.pathname.indexOf('multifactor-authentication') > -1)) ? false : window !== window.parent && !window.opener; // Remove this line to use Angular Universal
    // added code to load mfa/password policy page in iframe
    if (window !== window.parent && !window.opener && ((window.location.pathname.indexOf('resetpassword') > -1) || (window.location.pathname.indexOf('email-authentication') > -1) || (window.location.pathname.indexOf('multifactor-authentication') > -1))) {

      //this.router.navigate([window.location.pathname]);
     //this.router.navigate([window.location.href]); //to fix  source client id, redirect uri null values when request url came from iframe
     //this.router.navigateByUrl(window.location.href);
     this.router.navigate([window.location.pathname],{queryParams: {qs: window.location.search.replace("?qs=","") }});
     return;
    }

    this.setLoginDisplay();
    // removed the below method from constructor and added it in ngoninit.
    this.authService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult | null) => {
        if (result && result.account) {
          console.log('Redirect handled successfully:', result);
          // Potentially set active account here
          this.authService.instance.setActiveAccount(result.account);
        }
      },
      error: (error) => {

        this.LogError("Log.app.component.ts.handleRedirectObservable", "Error :" + error.errorMessage, this.clientId);
        if (error.errorMessage &&
          (error.errorMessage.indexOf('AADSTS50058') !== -1 || error.errorMessage.indexOf('50140') != -1)) {
          this.LogError("Log.app.component.ts.handleRedirectObservable1", "Error :" + error.errorMessage, this.clientId);
          // This is a KMSI(Keep Me Sign in)-related error
          console.log('KMSI prompt was shown');
          // You might want to retry login or inform the user
        }
      }
    });

    /* const callbackId: string = this.authService.instance.addPerformanceCallback((events: PerformanceEvent[]) => {
      events.forEach(event => {
          console.log(event);
          this.LogError("Log.app.component.ts.addPerformanceCallback", "Info : event: "+ this.commonUtilSvc.ConvertObjToJsonString(event), this.clientId);
      });
    }); */
    // const callbackId: string = this.authService.instance.addPerformanceCallback((events: PerformanceEvent[]) => {
    //   try {
    //     events.forEach(event => {
    //       console.log(event);
    //       this.LogError("Log.app.component.ts.addPerformanceCallback", "Info : event: "+ this.commonUtilSvc.ConvertObjToJsonString(event), this.clientId);
    //       });
    //   } catch (error) {
    //     console.error('Error occurred while logging MSAL performance event:', error);
    //   }
    // });
    // const removed: boolean = this.authService.instance.removePerformanceCallback(callbackId);
    /* const event: PerformanceEvent = {
      correlationId: "03cad3ff-6682-4e3d-a0b4-d517b531c718",
      durationMs: 1873,
      endPageVisibility: "hidden",
      fromCache: false,
      name: "acquireTokenSilent",
      startPageVisibility: "visible",
      startTimeMs: 1636414041888,
      success: true,
        silentCacheClientAcquireTokenDurationMs: 0,
        silentRefreshClientAcquireTokenDurationMs: 150,
        silentIframeClientAcquireTokenDurationMs: 0,
        cryptoOptsGetPublicKeyThumbprintDurationMs: 200,
        cryptoOptsSignJwtDurationMs: 8,
        clientId: "b50703d7-d12b-4ddc-8758-91053fe0aba4",
        authority: "https://login.microsoftonline.com/common",
        libraryName: "@azure/msal-browser-1p",
        libraryVersion: "2.22.2-beta.2",
        appName: "my-application",
        appVersion: "1.0.0"
      } */


    //You'll have to listen for the ACQUIRE_TOKEN_FAILURE and clear the localstorage yourself. 
    // this.msalBroadcastService.msalSubject$.pipe(filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_FAILURE ||  msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE)).subscribe({
    //   next: () => {
    //     let msalInstance: PublicClientApplication = this.authService.instance as PublicClientApplication;
    //     this.LogError("Log.app.component.ts.msalBroadcastService.msalSubject.EventType.EventType.LOGIN_FAILUREORACQUIRE_TOKEN_FAILURE", "Info : Clearing MSAL Browser Storage", this.clientId);
    //     msalInstance['browserStorage'].clear();
    //   }
    // });
    //End
    /* this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = "/";
        } else {
          this.setLoginDisplay();
        }
      });
    
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      })

      this.loginPopup(); */
  }

  setLoginDisplay() {

    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  loginPopup() {

    if (this.msalGuardConfig.authRequest) {
      this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
        .subscribe((response: AuthenticationResult) => {
          this.authService.instance.setActiveAccount(response.account);
        });
    } else {
      this.authService.loginPopup()
        .subscribe((response: AuthenticationResult) => {
          this.authService.instance.setActiveAccount(response.account);
        });
    }

    //alert(this.authService.instance.getTokenCache());
  }

  logout(popup?: boolean) {
    let returnUrl = window.location.href; //+"/rpost-authentication/{clienId}/{callbackUrl}";
    let clientId = localStorage.getItem("clienIdLS")!;
    let callbackUrl = localStorage.getItem("callbackUrl_" + clientId)!;
    //returnUrl=returnUrl.replace("{clienId}",clientId).replace("{callbackUrl}",callbackUrl);

    if (popup) {
      this.authService.logoutPopup({

        //mainWindowRedirectUri: "/"
        /* mainWindowRedirectUri:"http://localhost:53577/rpost-authentication/89278687-d54e-4321-81af-9e0d5f2f8cda/trackinportalurl" */
        mainWindowRedirectUri: returnUrl //"http://{returnUrl}/rpost-authentication/{clienId}/{trackinportalurl}"

      });
    } else {
      this.authService.logoutRedirect();
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
